import { Component, Input } from '@angular/core';
import { DetailDataOrderModel } from 'src/app/models/detail-data-order.model';

@Component({
  standalone: false,
  selector: 'app-order-information',
  templateUrl: './order-information.component.html',
})
export class OrderInformationComponent {
  @Input() detailOrder!: DetailDataOrderModel;
  @Input() loading: boolean = true;

  private readonly statusClassMap: Record<string, string> = {
    'Diterima': 'status-success',
    'Dipacking': 'status-info',
    'Retur': 'status-danger',
    'Dikirim': 'status-warning',
    'Diajukan': 'status-danger',
    'Batal': 'status-danger'
  };

  private readonly statusLabelMap: Record<string, string> = {
    'Dipacking': 'Packed',
    'Dikirim': 'Sent',
    'Diterima': 'Received',
    'Retur': 'Return',
    'Diajukan': 'Submitted',
    'Batal': 'Canceled'
  };

  handleClassStatus(status: string): string {
    return this.statusClassMap[status] || '';
  }

  handleStatusOrder(status: string): string {
    return this.statusLabelMap[status] || '';
  }
}
